import { useConditionFieldPath } from './useConditionFieldPath';

export const useConditionFieldFieldPath = () => {
  const condition = useConditionFieldPath();
  return `${condition}.field` as const;
};
